export default __webpack_public_path__ + "static/media/1831.23a0a4dd.png";